module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, undefined) {
  "use strict";

  fox.registerWidget(
    "Control_Select_Dynamic",
    {
      configure: function (options) {
        this.registerOptions("", {
          manualRender: true,
          customOptions: null,
          preset: null,
          limit: 999,
          widgets: {
            dl: {
              widget: "Datalayer",
              method: "Site.getAvailiableSexualOrientations",
            },
          },
          handleWom: {
            dlLoaded: {
              widget: "#dl",
              event: ["loaded", "success"],
              callback: "_handleDlLoad",
            },
          },
        });

        this.callParent("configure", arguments);
      },

      running: function () {
        this.dl = this.rwom1("#dl");
        this.getDataFromServer();

        this.callParent("running", arguments);
      },

      activate: function () {
        this.callParent("activate", arguments);

        if (this.getOption("loadOnActivate")) {
          this.getDataFromServer();
        } else {
          this.render();
        }
      },

      deactivate: function () {
        this.callParent("deactivate", arguments);

        this.value = null;
      },

      _handleDlLoad: function (response, dl, e) {
        var options = this.apiIsDl()
          ? dl.getCollection()
          : response.answer.response;

        if (fox.isObject(options)) {
          options = fox.toArray(options);
        }

        this.selectOptions = options;
        this.hookWrapper("prepareSelectOptions");
        this.setOption("select.options", this.selectOptions);

        this.render();
      },

      setValue: function (value, skipEvent) {
        if (this._indom) {
          this.callParent("setValue", arguments);

          return;
        }

        this.waitEvent(
          this,
          "addedToDom",
          function () {
            this.setValue(value, skipEvent);
          }.bind(this)
        );
      },

      getDataFromServer: function () {
        if (this.apiIsDl()) {
          this.dl.load();

          return;
        }
        let preset =
          this.getOption("preset") !== null && this.getOption("preset").length > 0
            ? { preset: this.getOption("preset"), limit: this.getOption("limit") }
            : {};
        this.dl.send(preset);
      },

      prepareSelectOptions: function () {
        var opts = this.getOption("customOptions") || [];
        fox.each(
          this.selectOptions,
          function (data) {
            var title = data.name || data.alias;
            opts.push({
              title: this.getTranslation ? this.getTranslation(title) : title,
              value: data.id,
            });
          },
          this
        );

        this.selectOptions = opts;
      },

      apiIsDl: function () {
        return fox.oop.instanceOf(this.dl, "Datalayer");
      },
    },
    "Control_Select"
  );
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/controls/select/dynamic.js
// module id = 305
// module chunks = 2